export default "__VITE_ASSET__Djx$goeu__"